import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  isOpenBanner: false,
  isOpenModalChangeProfile: false,
  isOpenModalUpload: false,
  isOpenModalDeleteFile: false,
  bannerMsg: '',
}

export const detailFarmersSlice = createAppSlice({
  name: 'detailFarmers',
  initialState,
  reducers: (create) => ({
    toggleBannerDetail: create.reducer((state, { payload }) => {
      state.isOpenBanner = !state.isOpenBanner
    }),
    toggleModalChangeProfile: create.reducer((state, { payload }) => {
      state.isOpenModalChangeProfile = !state.isOpenModalChangeProfile
    }),
    toggleModalUpload: create.reducer((state, { payload }) => {
      state.isOpenModalUpload = !state.isOpenModalUpload
    }),
    toggleModalDeleteFile: create.reducer((state, { payload }) => {
      state.isOpenModalDeleteFile = !state.isOpenModalDeleteFile
    }),
    setBannerMsg: create.reducer((state, { payload }) => {
      state.bannerMsg = payload
    }),
  }),
  extraReducers: (builder) => {},
})

export const {
  toggleModalChangeProfile,
  toggleBannerDetail,
  toggleModalUpload,
  toggleModalDeleteFile,
  setBannerMsg,
} = detailFarmersSlice.actions

export default detailFarmersSlice.reducer
